import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ArchiveIcon, AlertTriangleIcon } from 'lucide-react';
interface BulkArchiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  count: number;
}
export const BulkArchiveModal: React.FC<BulkArchiveModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  count
}) => {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-914">
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-915">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} className="bg-surface-elevated rounded-2xl shadow-2xl max-w-md w-full border border-custom overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-916">
          {/* Header */}
          <div className="flex items-start justify-between p-6 border-b border-custom" data-id="element-917">
            <div className="flex items-start gap-4" data-id="element-918">
              <div className="w-12 h-12 bg-red-50 text-red-600 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-919">
                <ArchiveIcon size={24} data-id="element-920" />
              </div>
              <div data-id="element-921">
                <h2 className="text-lg font-bold text-text-primary mb-1" data-id="element-922">
                  Archive {count} Classrooms?
                </h2>
                <p className="text-sm text-text-secondary" data-id="element-923">
                  These classrooms will be closed for the current academic year.
                </p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 rounded-lg hover:bg-surface transition-colors" data-id="element-924">
              <XIcon size={20} className="text-text-secondary" data-id="element-925" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 space-y-4" data-id="element-926">
            <div className="bg-orange-50 border border-orange-100 rounded-xl p-4 flex gap-3" data-id="element-927">
              <AlertTriangleIcon className="text-orange-500 flex-shrink-0" size={20} data-id="element-928" />
              <div className="text-sm text-orange-800" data-id="element-929">
                <p className="font-semibold mb-1" data-id="element-930">What happens next:</p>
                <ul className="list-disc list-inside space-y-1 opacity-90" data-id="element-931">
                  <li data-id="element-932">Student enrollments will be ended</li>
                  <li data-id="element-933">Records and reports are preserved</li>
                  <li data-id="element-934">You can recreate these classrooms for the new year</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 p-6 bg-surface border-t border-custom" data-id="element-935">
            <button onClick={onClose} className="px-5 py-2.5 border border-custom text-text-primary rounded-xl font-semibold hover:bg-surface-elevated transition-colors" data-id="element-936">
              Cancel
            </button>
            <button onClick={() => {
            onConfirm();
            onClose();
          }} className="px-5 py-2.5 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition-colors shadow-sm" data-id="element-937">
              Archive Classrooms
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
};